import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './Modal.css';
import { useTranslation } from 'react-i18next';
import { submitFormData } from '../utils/api';
import { URL } from '../utils/constants';
import check from '../assets/icons/check.png'

const Modal = ({ show, onClose, source }) => {
  const { t } = useTranslation();
  
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);

  const [formData, setFormData] = useState({
    telefono: '',
    email: '',
    emailcheck: '',
    nombre: '',
    rol: '',
    recaptcha: '',
    formType: [],
    comments: '', // Nuevo campo para comentarios FPN59
   /*  source: source, */
  });

  const [formErrors, setFormErrors] = useState({
    telefono: false,
    email: false,
    emailcheck: false,
    nombre: false,
    rol: false,
    recaptcha: true,
    comments: false, // Error de validación para comentarios FPN59
  });

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    const isFormValid = Object.values(formData).every(value => value !== '');
    const isEmailsMatch = formData?.email === formData?.emailcheck;
    const isTelefonoValid = validateTelefono(formData?.telefono);
    const isFormTypeValid = formData.formType?.length > 0;
    const isCommentsValid = validateComments(formData.comments);
    setIsSubmitDisabled(
      !(isFormValid && isEmailsMatch && isTelefonoValid && isFormTypeValid && isCommentsValid)
    );
  }, [formData]);

  const validateTelefono = (telefono) => {
    const telefonoRegex = /^[0-9]{9}$/; // Cambia esta expresión regular según el formato de teléfono que necesites
    return telefonoRegex.test(telefono);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateComments = (comments) => {
    return comments.trim().length > 0 && comments.trim().length <= 150;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'telefono') {
      setFormErrors({
        ...formErrors,
        telefono: !validateTelefono(value),
      });
    }

    if (name === 'email') {
        setFormErrors({
          ...formErrors,
          email: !validateEmail(value),
        });
      }

      if (name === 'emailcheck') {
        setFormErrors({
          ...formErrors,
          emailcheck: value !== formData?.email,
        });
      }

      if (name === 'comments') {
        setFormErrors({
          ...formErrors,
          comments: !validateComments(value),
        });
      }
  };
  

  const handleCheckChange = (e) => {
    setFormData({
      ...formData,
      rol: e.target.value,
    });
  };
  const handleCheckChangeFormType = (e) => {
    const { value, checked } = e.target;
  
    setFormData((prevFormData) => {
      // Ensure prevFormData.formType is always an array
      const currentFormType = prevFormData?.formType || [];
  
      const newFormType = checked
        ? [...currentFormType, value] // Add value if checked
        : currentFormType.filter((type) => type !== value); // Remove value if unchecked
  
      return {
        ...prevFormData,
        formType: newFormType,
      };
    });
  };

  const handleRecaptchaChange = (value) => {
    setFormData({
      ...formData,
      recaptcha: value,
    });
    setFormErrors({
      ...formErrors,
      recaptcha: value === null,
    });
  };

  const handleCancel = () => {
    onClose();
    setFormData({
        telefono: '',
        email: '',
        emailcheck: '',
        nombre: '',
        rol: '',
        recaptcha: '',
    });
    setFormErrors({
        telefono: false,
        email: false,
        emailcheck: false,
        nombre: false,
        rol: false,
        recaptcha: true,
    })
  };

  /* const handleSubmit = () => {
     
    const postParam = {
      email: formData?.email,
      name: formData?.nombre,
      formType: formData?.formType,
      rol: formData?.rol,
      phone: formData?.telefono
    }

    console.log('params', postParam);

    onClose();
    setFormData({
      telefono: '',
      email: '',
      emailcheck: '',
      nombre: '',
      rol: '',
      recaptcha: '',
      formType: [],
    });
  }; */
  const mapFormTypeToEnglish = (formType) => {
    return formType.map(type => {
      if (type === t("modal.formTypeAlerts")) {
        return "alerts";
      } else if (type === t("modal.formTypeTrip")) {
        return "tripupdates";
      }
      return type.toLowerCase();
    });
  };

  const mapRoleToEnglish = (role) => {
    if (role === t("modal.rolOperator")) {
      return "operator";
    } else if (role === t("modal.rolAdmin")) {
      return "administrator";
    } else if (role === t("modal.rolOthers")) {
      return "others";
    }
    return role.toLowerCase();
  };

  const handleSubmit = async () => {
    const mappedFormType = mapFormTypeToEnglish(formData?.formType);
    const mappedRole = mapRoleToEnglish(formData?.rol);
    console.log(formData);
    try {
      await submitFormData({
        telefono: formData?.telefono,
        email: formData?.email,
        nombre: formData?.nombre,
        rol: mappedRole,
        formType: mappedFormType,
        comments: formData?.comments,
      });
   
      console.log('Solicitud POST exitosa');
      setShowThankYouMessage(true);
      setTimeout(() => {
        setShowThankYouMessage(false);
        onClose();
        setFormData({
          telefono: '',
          email: '',
          emailcheck: '',
          nombre: '',
          rol: '',
          recaptcha: '',
          formType: [],
          comments: '',
        });
      }, 4000);
    } catch (error) {
      console.error('Error al enviar la solicitud POST:', error);
    }}

  

  const handleClearInput = (field) => {
    setFormData({
      ...formData,
      [field]: '',
    });

   /*  if (field === 'telefono') {
      setFormErrors({
        ...formErrors,
        telefono: true,
      });
    } */
  };
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className={showThankYouMessage ? "modal-contentThanks" :  "modal-content"} >
      {showThankYouMessage ? (
       <div className="thank-you-message">
        <img className='iconoCheck' src={check} alt="check" />
         <h2>{t("modal.thankYouMessage")}</h2>
       </div>
     ) : (
      <>
       <div className='titleH2'>
          <h2 className='title'>{t("modal.title")}{/*  / {source} */}
          </h2>
        </div>
        <form className='formContainer'>
          <div className="div1Modal">
          <div className="radio-container">
    <div className='divInput'>
      <input
        type="checkbox"
        id="alertes"
        name="formType"
        value={t("modal.formTypeAlerts")}
        checked={formData.formType?.includes(t("modal.formTypeAlerts"))}
        onChange={handleCheckChangeFormType}
      />
      <label className='labelStyleUp' htmlFor="alertes">{t("modal.formTypeAlerts")}</label>
    </div>
    <div className='divInput'>
      <input
        type="checkbox"
        id="tripupdates"
        name="formType"
        value={t("modal.formTypeTrip")}
        checked={formData.formType?.includes(t("modal.formTypeTrip"))}
        onChange={handleCheckChangeFormType}
      />
      <label className='labelStyleUp' htmlFor="tripupdates">{t("modal.formTypeTrip")}</label>
    </div>
  </div>
            <label htmlFor="telefono">{t("modal.telephone")}</label>
            <div className="input-container">
              <input
                type="text"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
              />
              <span
                className="clear-button"
                onClick={() => handleClearInput('telefono')}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
            </div>
            {formErrors.telefono && <span className="error">{t("modal.telephoneError")}</span>}
          </div>
          <div className="div2Modal">
          <div className="radio-container2">

        </div>
            <label htmlFor="email">{t("modal.email")}</label>
            <div className="input-container">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <span
                className="clear-button"
                onClick={() => handleClearInput('email')}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
            </div>
            {formErrors.email && <span className="error">{t("modal.emailError")}</span>}
          </div>
          <div className="div3Modal">
            {/* <label>Rol:</label> */}
            <div className='divInput'>
              <input
                type="radio"
                id="operador"
                name="rol"
                value={t("modal.rolOperator")}
                checked={formData.rol === t("modal.rolOperator")}
                onChange={handleCheckChange}
              />
              <label className='labelStyle' htmlFor="operador">{t("modal.rolOperator")}</label>
            </div>
            <div className='divInput'>
              <input
                type="radio"
                id="administracion"
                name="rol"
                value={t("modal.rolAdmin")}
                checked={formData.rol === t("modal.rolAdmin")}
                onChange={handleCheckChange}
              />
              <label className='labelStyle' htmlFor="administracion">{t("modal.rolAdmin")}</label>
            </div>
            <div className='divInput'>
              <input
                type="radio"
                id="altres"
                name="rol"
                value={t("modal.rolOthers")}
                checked={formData.rol === t("modal.rolOthers")}
                onChange={handleCheckChange}
              />
              <label className='labelStyle' htmlFor="altres">{t("modal.rolOthers")}</label>
            </div>
            {/* {formErrors.rol && <span className="error">Rol es requerido.</span>} */}
          </div>
          <div className="div4Modal">
            <label htmlFor="emailcheck">{t("modal.checkEmail")}</label>
            <div className='input-container'>
              <input
                type="email"
                id="emailcheck"
                name="emailcheck"
                value={formData.emailcheck}
                onChange={handleChange}
              />
              <span
                className="clear-button"
                onClick={() => handleClearInput('emailcheck')}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </span>
            </div>
            {formErrors.emailcheck && <span className="error">{t("modal.checkEmailError")}</span>}
          </div>
          <div className="div5Modal">
  <label htmlFor="nombre">{t("modal.name")}</label>
  <div className='input-container'>
    <input
      type="text"
      id="nombre"
      name="nombre"
      value={formData.nombre}
      onChange={handleChange}
    />
    <span
      className="clear-button"
      onClick={() => handleClearInput('nombre')}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="green"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </span>
  </div>
             <div className="divComments">
                <label htmlFor="comments">{'AQUI'}</label>
                <textarea
                  id="comments"
                  name="comments"
                  value={formData.comments}
                  onChange={handleChange}
                  rows="4"
                  maxLength="150"
                  className={formErrors.comments ? "error-input" : ""}
                />
                {formErrors.comments && (
                  <span className="error">{t("modal.commentsError")}</span>
                )}
              </div>
  
  {/* <div className="radio-container">
    <div className='divInput'>
      <input
        type="radio"
        id="alertes"
        name="rol"
        value="ALERTES"
        checked={formData.rol === 'ALERTES'}
        onChange={handleCheckChange}
      />
      <label className='labelStyle' htmlFor="alertes">Alertes</label>
    </div>
    <div className='divInput'>
      <input
        type="radio"
        id="tripupdates"
        name="rol"
        value="TRIPUPDATES"
        checked={formData.rol === 'TRIPUPDATES'}
        onChange={handleCheckChange}
      />
      <label className='labelStyle' htmlFor="tripupdates">Tripupdates</label>
    </div>
  </div> */}
</div>
          <div className="div6Modal">
            <ReCAPTCHA
            className='captcha'
              sitekey={URL?.recaptcha_key}/* "6Lf3TOMUAAAAABMDkA42oQEZYfP8L2W_jzAtQuAJ" */
              onChange={handleRecaptchaChange}
            />
            {/* {formErrors.recaptcha && <span className="error">Captcha es requerido.</span>} */}
          </div>
          <div className="div7Modal buttons">
            <button className="buttonCancel" type="button" onClick={handleCancel}>{t("modal.cancelButtoon")}</button>
            <button className="buttonSend" type="button" onClick={handleSubmit} disabled={isSubmitDisabled}>
              {t("modal.submitButton")}
            </button>
          </div>
          
        </form>
      </>
     )}
       
      </div>
    </div>
  );
};

export default Modal;